import angular from 'angular';
import uiRouter from 'angular-ui-router';
import BrandComponent from './brand.component';

let BrandModule = angular
  .module('Brand', [uiRouter])

  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newBrand', {
        url: '/brands/new',
        component: 'brand',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      })
      .state('editBrand', {
        url: '/brands/:id',
        component: 'brand',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          brand: (BrandsService, $stateParams) => {
            return BrandsService.findById($stateParams.id);
          }
        }
      });
  })
  .component('brand', BrandComponent).name;

export default BrandModule;
